import React from 'react'
import './index.css';

function content() {
    return (
        <div>
            <h2>
            WeaApp gathers the best and most comprehensive weather data to 
                deliver forecasts with Superior Accuracy.
            </h2>
        </div>
    )
}

export default content
